"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminReindex = exports.reindexCall = exports.getRepositories = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const abortable_fetch_1 = require("../../utils/abortable-fetch");
const table_field_1 = require("../../components/table-field/table-field");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const checkbox_1 = require("../../components/checkbox/checkbox");
const react_intl_1 = require("react-intl");
const snackbar_context_1 = require("../../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../../composite/snackbar/snackbar-types");
const admin_context_1 = require("./admin-context");
/**
 * Gets all stores.
 */
function getRepositories(url) {
    return abortable_fetch_1.abortableFetch(url, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'GET',
    });
}
exports.getRepositories = getRepositories;
/**
 * Gets all stores.
 */
function reindexCall(url, names) {
    return abortable_fetch_1.abortableFetch(url, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'POST',
        body: JSON.stringify(names),
    });
}
exports.reindexCall = reindexCall;
function AdminReindex() {
    const intl = react_intl_1.useIntl();
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const { reindexUrl } = react_1.useContext(admin_context_1.AdminContext);
    const [repositories, setRepositiories] = react_1.useState([]);
    const [loading, setLoading] = react_1.useState(false);
    const CheckboxCell = react_1.useMemo(() => function CheckboxCell({ value, index, }) {
        return (react_1.default.createElement(checkbox_1.Checkbox, { value: value, onChange: () => {
                setRepositiories((repositories) => [
                    ...repositories.slice(0, index),
                    { ...repositories[index], active: !repositories[index].active },
                    ...repositories.slice(index + 1),
                ]);
            } }));
    }, []);
    const columns = [
        {
            name: 'Výběr',
            datakey: 'active',
            width: 100,
            CellComponent: CheckboxCell,
        },
        {
            name: 'Repository',
            datakey: 'name',
            width: 500,
        },
    ];
    const reindex = event_callback_hook_1.useEventCallback(async (names) => {
        try {
            setLoading(true);
            await reindexCall(reindexUrl, names).none();
            const message = intl.formatMessage({
                id: 'EAS_DEVTOOLS_REINDEX_MSG_SUCCESS',
                defaultMessage: 'Reindexace dokončena',
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
            setLoading(false);
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const message = intl.formatMessage({
                    id: 'EAS_DEVTOOLS_REINDEX_MSG_ERROR',
                    defaultMessage: 'Chyba reindexace: {detail}',
                }, { detail: err.message });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw err;
            }
        }
    });
    const reindexSelected = event_callback_hook_1.useEventCallback(() => {
        const names = repositories
            .filter((repository) => repository.active)
            .map((repository) => repository.name);
        return reindex(names);
    });
    const reindexAll = event_callback_hook_1.useEventCallback(() => {
        const names = repositories.map((repository) => repository.name);
        return reindex(names);
    });
    react_1.useEffect(() => {
        getRepositories(reindexUrl)
            .json()
            .then((repositiories) => {
            setRepositiories(repositiories.map((repository) => ({
                name: repository,
                active: false,
            })));
        });
    }, [reindexUrl]);
    return (react_1.default.createElement(Grid_1.default, { container: true },
        react_1.default.createElement(Grid_1.default, { item: true, xs: false, sm: 1 }),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 10 },
            react_1.default.createElement(Box_1.default, { height: 20 }),
            react_1.default.createElement(table_field_1.TableField, { maxRows: 15, showToolbar: false, showRadioCond: () => false, value: repositories, columns: columns, onChange: lodash_1.noop }),
            react_1.default.createElement(Box_1.default, { height: 20 })),
        react_1.default.createElement(Grid_1.default, { item: true, xs: false, sm: 1 }),
        react_1.default.createElement(Grid_1.default, { item: true, xs: false, sm: 1 }),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 10 },
            react_1.default.createElement(Box_1.default, { display: "flex", flexDirection: "row-reverse" },
                react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", type: "submit", disabled: loading, startIcon: loading && react_1.default.createElement(CircularProgress_1.default, { size: "20px", color: "inherit" }), onClick: reindexAll },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DEVTOOLS_REINDEX_BTN_REINDEX_ALL", defaultMessage: "Reindexovat v\u0161e" })),
                react_1.default.createElement(Box_1.default, { width: 10 }),
                react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", type: "submit", disabled: loading, startIcon: loading && react_1.default.createElement(CircularProgress_1.default, { size: "20px", color: "inherit" }), onClick: reindexSelected },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DEVTOOLS_REINDEX_BTN_REINDEX", defaultMessage: "Reindexovat" })))),
        react_1.default.createElement(Grid_1.default, { item: true, xs: false, sm: 1 })));
}
exports.AdminReindex = AdminReindex;
//# sourceMappingURL=admin-reindex.js.map